import { createContext, useContext, useRef, useState } from "react";
import loveSong from "../assets/love-song.mp3";

const MusicContext = createContext();

export const useMusic = () => {
  const context = useContext(MusicContext);
  if (!context) {
    throw new Error("useMusic must be used within a MusicProvider");
  }
  return context;
};

export const MusicProvider = ({ children }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const startMusic = () => {
    if (!audioRef.current) {
      audioRef.current = new Audio(loveSong);
      audioRef.current.loop = true;
      audioRef.current.volume = 0.7;
    }

    if (!isPlaying) {
      audioRef.current.play().then(() => {
        setIsPlaying(true);
        console.log("Background music started");
      }).catch(error => {
        console.log("Failed to play music:", error);
      });
    }
  };

  const stopMusic = () => {
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
  };

  return (
    <MusicContext.Provider value={{ isPlaying, startMusic, stopMusic }}>
      {children}
    </MusicContext.Provider>
  );
};
